// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row:nth-child(even) {
  background: #eeeeee;
  margin: 0 -2rem;
  padding: 0 1rem;
}

.RepairCostDetailsRow__HeaderRow {
  color: var(--smartflip-blue);
  font-weight: bold;
  margin-top: 1rem;
  padding-bottom: 0.5rem;
}
.RepairCostDetailsRow__Icon--delete {
  background-color: transparent;
  color: #f44336;
}`, "",{"version":3,"sources":["webpack://./apps/app/src/app/views/property-details/components/repair-detail-costs/repair-cost-row/repair-cost-row.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,eAAA;EACA,eAAA;AACF;;AAGE;EACE,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AAAJ;AAII;EACE,6BAAA;EACA,cAAA;AAFN","sourcesContent":[".row:nth-child(even) {\n  background: #eeeeee;\n  margin: 0 -2rem;\n  padding: 0 1rem;\n}\n\n.RepairCostDetailsRow {\n  &__HeaderRow {\n    color: var(--smartflip-blue);\n    font-weight: bold;\n    margin-top: 1rem;\n    padding-bottom: 0.5rem;\n  }\n\n  &__Icon {\n    &--delete {\n      background-color: transparent;\n      color: #f44336;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
